import * as React from 'react'
import { twMerge } from 'tailwind-merge'

interface SummaryFooterProps extends React.ComponentProps<'div'> {}

export function SummaryFooter({ className, children, ...props }: SummaryFooterProps) {
  return (
    <div className={twMerge('flex w-full items-center justify-between', className)} {...props}>
      <div className={'flex items-center gap-3'}>{children}</div>
    </div>
  )
}
